module.exports = __webpack_public_path__ + "static/img/20010 (7).f08cffc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20010 (7).jpg
// module id = 0mdU
// module chunks = 14